import React, {
  useCallback,
} from 'react';
import {
  Route,
  Routes,
  Navigate,
  useParams,
  useNavigate,
} from 'react-router-dom';
import {
  getStatus,
} from 'redux-resource';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';
import i18n from 'i18next';

import {
  formatTimeAgo,
} from 'web-utils';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  EntityIcon,
} from 'web-components';

import {
  Flex,
  icons,
} from 'web-styled';

import * as S from './styled';

const Items = () => {
  const { tag, tagType } = useParams();
  const mapState = useCallback(state => ({
    searchStatus: getStatus(
      state,
      'searchResults.requests.getSearchResults.status',
    ),
    folderRoots: coreSelectors.getFolderRoots(state),
    items: coreSelectors.getTagedItems(
      tag,
      tagType,
    )(state),
  }), [tag, tagType]);

  const { items } = useSelector(mapState, shallowEqual);

  return (
    <Flex fillSpace column>
      {items.length > 0 ? (items.map(item => (
        <S.Item
          key={item.id}
        >
          <Flex
            spacing={10}
            fillSpace
            align="center"
            justify="space-between"
          >
            <Flex
              spacing={10}
              align="center"
              justify="center"
            >
              <Flex
                width="18px"
                height="20px"
                align="center"
                justify="center"
              >
                <EntityIcon
                  resourceType={item.type}
                />
              </Flex>
              <S.Name
                to={`/${item.type}/${item.id}`}
              >
                {item.name}
              </S.Name>
            </Flex>
            <S.Time>
              {formatTimeAgo(item.updated_at)}
            </S.Time>
          </Flex>
        </S.Item>
      ))) : (
        <S.Empty>
          <S.EmptyIcon
            src={icons[`${tagType}Empty`]}
            alt=""
          />
          <span>
            {i18n.t('no_found', { type: tagType === 'all' ? 'results' : `$t(${tagType})` })}
          </span>
        </S.Empty>
      )}
    </Flex>
  );
};

export default Items;
